/**
 * This function translates the answer to array even if it is a single value
 * Reason: Backend model is configured such that it will always consider multiple choice question as array
 * Though this is used for only multi select , adding the isSelectType so that we can extend the same function for other cases
 */

import isArray from 'lodash/isArray';

function formatAnswerBasedOnType(answer, isSelectType) {
  if (isSelectType && !isArray(answer)) {
    return [answer];
  }
  return answer;
}

export default formatAnswerBasedOnType;
